export default __webpack_public_path__ + "media/images/ccn-preta-7cbb3ad635ab8685dafa83dfd0b04ea1.png";